import get from 'utils/get';

export default (allLocations, locationSlug) =>
  allLocations.find(location => get(location, 'slug') === locationSlug);
